import { z } from 'zod';

const cardSizeSchema = z.object({
  w: z.number().int().positive(),
  h: z.number().int().positive(),
});

const haSchema = z.object({
  url: z.string().url(),
  websocket: z.string().url(),
  fallbackUrl: z.string().url().optional(),
  fallbackWebsocket: z.string().url().optional(),
});

const assistantSchema = z.object({
  url: z.string().url(),
});

const themeSchema = z.object({
  mode: z.enum(['dark', 'light']),
  primaryColor: z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/, 'primaryColor must be a 6-digit hex color like #3b82f6')
    .default('#3b82f6'),
});

const generatorSchema = z.object({
  hiddenLabels: z.array(z.string()).default(['rsc:hidden']),
  pinnedLabels: z.array(z.string()).default(['rsc:pinned']),
  heroLabels: z.array(z.string()).default(['rsc:hero']),
  compactLabels: z.array(z.string()).default(['rsc:compact']),
  defaultCardSize: cardSizeSchema.default({ w: 3, h: 2 }),
  compactCardSize: cardSizeSchema.default({ w: 2, h: 1 }),
  gridColumns: z.number().int().min(4).max(24).default(12),
});

export const AppSettingsSchema = z.object({
  ha: haSchema,
  assistant: assistantSchema,
  theme: themeSchema,
  generator: generatorSchema,
  mockRegistry: z.boolean().default(false),
});

export type AppSettings = z.infer<typeof AppSettingsSchema>;

export const defaultSettings: AppSettings = {
  ha: {
    url: 'http://homeassistant:8123',
    websocket: 'ws://homeassistant:8123/api/websocket',
  },
  assistant: {
    url: 'http://assistant:8000',
  },
  theme: {
    mode: 'dark',
    primaryColor: '#3b82f6',
  },
  generator: {
    hiddenLabels: ['rsc:hidden'],
    pinnedLabels: ['rsc:pinned'],
    heroLabels: ['rsc:hero'],
    compactLabels: ['rsc:compact'],
    defaultCardSize: { w: 3, h: 2 },
    compactCardSize: { w: 2, h: 1 },
    gridColumns: 12,
  },
  mockRegistry: false,
};
